<template>
    <div class="appBarInfos">
        <CurrencyTicker></CurrencyTicker>
    </div>
</template>

<script>
import CurrencyTicker from './CurrencyTicker.vue';
export default {
	components: { CurrencyTicker }
}
</script>

<style lang="scss" scoped>

</style>